import * as Config from '../../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import More from '../../common/More';
import DragIcon from '../../dnd/DragIcon';

function ColumnMore({ width, id, onClick, hasTouch = false, style }) {
  return (
    <div style={{ width, textAlign: `-webkit-center`, zIndex: 50, ...style}}>
      { hasTouch && <DragIcon /> }
      {(Config.LIST_HAS_MORE && !hasTouch) && <More id={`more-ref-${id}`} size={20} className={`item-more`} onClick={onClick} /> }
    </div>
  )
}

ColumnMore.propTypes = {
  width: PropTypes.number.isRequired,
  id: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  hasTouch: PropTypes.bool,
  style: PropTypes.object,
}

export default ColumnMore;
